export default "__VITE_ASSET__Cc1vPDTJ__"